import AjusteInventarioService from "@/services/inventario/AjusteInventarioService";

const fetch = (context, params) => {
  return AjusteInventarioService.fetch(params)
    .then(res => {
      context.commit('AJUSTE_INVENTARIO', res.data);
    });
};

export default {
  fetch,
};